var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8418 7.50004C0.774189 7.50006 0.708094 7.48002 0.651874 7.44246C0.595654 7.40491 0.551835 7.35152 0.52596 7.28906C0.500085 7.22659 0.493317 7.15786 0.50651 7.09155C0.519704 7.02524 0.552267 6.96433 0.600081 6.91653L6.91649 0.600123C6.9806 0.536015 7.06754 0.5 7.15821 0.5C7.24887 0.5 7.33582 0.536015 7.39992 0.600123C7.46403 0.664231 7.50005 0.75118 7.50005 0.841842C7.50005 0.932504 7.46403 1.01945 7.39992 1.08356L1.08352 7.39997C1.0518 7.43175 1.01412 7.45695 0.972643 7.47412C0.931162 7.4913 0.886696 7.50011 0.8418 7.50004Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15843 7.50004C7.11353 7.50011 7.06907 7.4913 7.02759 7.47412C6.98611 7.45695 6.94843 7.43175 6.91671 7.39997L0.600306 1.08356C0.536198 1.01945 0.500183 0.932504 0.500183 0.841842C0.500183 0.75118 0.536198 0.664231 0.600306 0.600123C0.664414 0.536015 0.751363 0.5 0.842025 0.5C0.932687 0.5 1.01964 0.536015 1.08374 0.600123L7.40015 6.91653C7.44796 6.96433 7.48053 7.02524 7.49372 7.09155C7.50691 7.15786 7.50015 7.22659 7.47427 7.28906C7.4484 7.35152 7.40458 7.40491 7.34836 7.44246C7.29214 7.48002 7.22604 7.50006 7.15843 7.50004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.131d2c8fe8af4c52644460845d1ffb99.svg";
export { ForwardRef as ReactComponent };